export const aboutInfo = {
  brandName: '香蕉文化漫画网',
  slogan: '让每一个人都能享受漫画的乐趣',
  founded: '2023年',
  description: '香蕉文化漫画网成立于2023年，是国内领先的在线漫画阅读平台之一。我们致力于为广大漫画爱好者提供最优质的阅读体验，汇聚海量精品韩漫、日漫、国漫资源，打造一站式漫画阅读社区。',
  mission: '我们的使命是让优质的漫画内容触手可及。通过不断优化的阅读技术和丰富的漫画资源库，为读者创造流畅、舒适、沉浸式的在线阅读体验。',
  vision: '成为华语世界最受欢迎的漫画阅读平台，推动漫画文化的传播与发展，让更多优秀漫画作品被看见、被喜爱。',
  features: [
    {
      icon: 'ri-smartphone-line',
      title: '多模式阅读',
      description: '支持下拉式、翻页、弹窗三种阅读模式，满足不同读者的阅读习惯，在手机和电脑上都能获得最佳体验。'
    },
    {
      icon: 'ri-database-2-line',
      title: '海量资源',
      description: '汇聚超过10万部精品漫画，涵盖韩漫、日漫、国漫等多元类型，每日及时更新，让读者追更不等待。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '高清画质',
      description: '所有漫画均采用高清扫描与优化处理，确保每一页画面清晰细腻，还原原作的视觉魅力。'
    },
    {
      icon: 'ri-user-heart-line',
      title: '免费阅读',
      description: '大量热门漫画提供免费全集阅读，让更多读者无门槛享受漫画带来的快乐，真正实现漫画自由。'
    }
  ],
  stats: [
    { value: '10万+', label: '漫画资源' },
    { value: '500万+', label: '活跃用户' },
    { value: '99.7%', label: '用户好评率' },
    { value: '24h', label: '极速更新' }
  ],
  testimonials: [
    {
      name: '小林',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
      role: '资深漫迷',
      content: '用了两年多了，更新速度超级快，画质也很好。下拉式阅读真的很方便，追更体验一流！'
    },
    {
      name: '阿杰',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20expression%2C%20modern%20casual%20look%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
      role: '日漫爱好者',
      content: '日漫资源很全，翻译质量也很高。特别喜欢翻页模式，有种看实体书的感觉！'
    },
    {
      name: '小雨',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%2C%20gentle%20smile%2C%20fashionable%20appearance%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
      role: '韩漫粉丝',
      content: '韩漫专区做得太好了！分类很清晰，找漫画特别方便。弹窗模式在手机上超级好用！'
    }
  ],
  contact: {
    email: 'support@xiangjiaowenhua.com',
    weixin: 'xiangjiaowenhua',
    weibo: '@香蕉文化漫画网',
    qqGroup: '888888888',
    address: '中国北京市朝阳区文化创意产业园A座',
    workingHours: '周一至周日 9:00 - 21:00'
  }
};